'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { useState, useEffect } from 'react';
import { BaseTranslations } from '../../baseTranslations';
import { AttrKeyValue } from '../../types/attributes';
import { VerticalType } from '../../types/cmsTypes';
import { useCmsClientContext } from '../../utils/cmsPageContext';
import { getClientTranslations } from '../../utils/translations/getClientTranslations';
import Button from '../Button';
import ArrowUp from '../icons/ArrowUp';
import CheckCircle from '../icons/CheckCircle';
import InfoCircle from '../icons/InfoCircle';
import Like from '../icons/Like';
import { RichText } from '../RichText';
import { WrapperInfoBlock } from './ProductContent';

const AttributeKeyValue: React.FC<AttrKeyValue & { vertical?: VerticalType }> = ({
  value,
  name,
  label,
  vertical,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);
  const [isScreenSizeDesktop, setIsScreenSizeDesktop] = useState(false);
  const [toggleList, setToggleList] = useState<{ [key: string]: boolean }>({});

  const labelAttributeTranslation =
    staticText[
      label?.toLowerCase().replace(/\s+/g, '_') as keyof typeof staticText
    ];

  const isBankingProductHighlight =
    context.brand === 'moneyhero' &&
    vertical === 'BANKING' &&
    name?.name === 'PRODUCT_CARD_TOP_BADGE';
  const handleToggle = (title: string) => {
    setToggleList((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  useEffect(() => {
    const checkScreenSize = () =>
      setIsScreenSizeDesktop(window.innerWidth >= 1280);

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (name?.name === 'BUNDLE_PRODUCT_OPTIONS') return null;

  const itemsList = value?.reduce((accum: JSX.Element[], current) => {
    const Icon = current?.key === 'pros' ? CheckCircle : InfoCircle;
    if (current?.values) {
      current.values.forEach((value) => {
        if (value?.value) {
          accum.push(
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={value?.value}
              className="relative mb-2 last:mb-0 md:mb-4"
            >
              <Icon className="absolute left-0 top-1 size-[18px] text-campaign/green-3" />
              <RichText className="quick-facts ml-6 font-medium text-sm leading-line-height/lg-relaxed md:text-lg md:leading-line-height/xl">
                {value?.value ?? ''}
              </RichText>
            </div>,
          );
        }
      });
    }

    return accum;
  }, []);

  const isHeaderOpen = toggleList[name?.name ?? ''];
  const visibleItems =
    isHeaderOpen || isScreenSizeDesktop
      ? (itemsList ?? [])
      : (itemsList?.slice(0, 3) ?? []);

  if (visibleItems?.length > 0)
    return (
      <WrapperInfoBlock
        icon={<Like />}
        title={
          isBankingProductHighlight
            ? staticText.product_highlight
            : !labelAttributeTranslation
              ? (label ?? '')
              : labelAttributeTranslation
        }
      >
        <ul>
          <li className="mb-2 last:mb-0 md:mb-4">{visibleItems}</li>
        </ul>
        {itemsList && itemsList.length > 3 && !isScreenSizeDesktop && (
          <Button
            onClick={() => handleToggle(name?.name ?? '')}
            variant="text"
            className="pl-0 text-text/link"
            endIcon={
              isHeaderOpen ? (
                <ArrowUp className="text-link" />
              ) : (
                <ArrowUp className="rotate-180 transition-transform text-link" />
              )
            }
          >
            {isHeaderOpen ? staticText?.show_less : staticText?.show_more}
          </Button>
        )}
      </WrapperInfoBlock>
    );
};

export default AttributeKeyValue;
